export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/5ba84b7c5997e2a9223c26a23a6fa17e.svg";